import useApps from '../manifest/useApps';

var useExtensions = function useExtensions() {
  var extensionFor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _useApps = useApps(),
      response = _useApps.response,
      loading = _useApps.loading,
      error = _useApps.error;

  if (loading) return [];
  if (error) return [];

  if (response && response.Data) {
    var apps = response.Data.map(function (ext) {
      return ext;
    });
    var extensions = [];
    apps.map(function (app) {
      if (!app.MicroserviceAppManifest) return;
      var manifest = app.MicroserviceAppManifest;
      if (!manifest.Extensions) return;
      if (!manifest.Extensions.length) return;
      manifest.Extensions.map(function (extension) {
        if (extensionFor && extension.For !== extensionFor) return;
        extensions.push({
          app: manifest.Id,
          extensionFor: extension.For,
          type: extension.Type,
          url: extension.URL
        });
      });
    });
    return extensions;
  }

  return [];
};

export default useExtensions;